import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrimengModule } from './primeng.module';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';

import {RippleModule} from "primeng/ripple";
import { DropdownComponent } from './components/dropdown/dropdown.component';

import { LoadingComponent } from './components/loading/loading.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ProvinciaDialogComponent } from './components/provincia-dialog/provincia-dialog.component';
import { ProvinciaDialogService } from './components/provincia-dialog/provincia-dialog.service';
import { CiudadDialogComponent } from './components/ciudad/ciudad-dialog.component';
import { CiudadDialogService } from './components/ciudad/ciudad-dialog.service';
import { alertComponent } from './components/alert/alert.component';
import { StepsComponent } from './components/step/step.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PrimengModule,
    RippleModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.5)',
      backdropBorderRadius: '4px',
      tertiaryColour: '#1976d2',
      fullScreenBackdrop: true,
    }),
    NgOtpInputModule
  ],
  declarations: [
    LoadingComponent,
    DropdownComponent,
    ProvinciaDialogComponent,
    CiudadDialogComponent,
    alertComponent,
    ErrorPageComponent,
    StepsComponent,
  ],
  exports: [
    LoadingComponent,
    PrimengModule,
    CommonModule,
    DropdownComponent,
    ProvinciaDialogComponent,
    CiudadDialogComponent,
    FormsModule,
    ReactiveFormsModule,
    alertComponent,
    ErrorPageComponent,
    NgxLoadingModule,
    StepsComponent,
  ],
  providers: [
    ProvinciaDialogService,
    CiudadDialogService
  ]
})
export class SharedModule { }
